/* ==========================================================================
   RP26 : Page de collection (repositionnement 2026)
   Comportements : barre de filtres sticky sous le header, panneaux de filtres,
   tiroir mobile, bascule 1/2 colonnes, bandeau tournant, flèches de défilement.
   ========================================================================== */
(function () {
  if (window.__rp26CollectionInit) return;
  window.__rp26CollectionInit = true;

  var d = document;

  /* --- 1. La barre de filtres se cale sous le header sticky du thème --- */
  function stickyTop() {
    var bar = d.querySelector('.rp26-filterbar');
    if (!bar) return;
    var header = d.querySelector('sticky-header') || d.querySelector('.section-header');
    var top = 0;
    if (header) {
      var r = header.getBoundingClientRect();
      // header visible en haut de fenêtre : on se cale juste dessous
      // on arrondit vers le haut : évite le filet blanc d'un demi-pixel sous le header
      if (r.bottom > 0 && r.top <= 1) top = Math.ceil(r.bottom);
    }
    bar.style.setProperty('--rp26-sticky-top', top + 'px');
  }
  ['scroll', 'resize'].forEach(function (e) {
    window.addEventListener(e, stickyTop, { passive: true });
  });
  stickyTop();

  /* --- 2. Panneaux de filtres (desktop) --- */
  d.addEventListener('click', function (e) {
    var trigger = e.target.closest('.rp26-filt > button');
    if (trigger) {
      var box = trigger.parentNode;
      var wasOpen = box.classList.contains('is-open');
      d.querySelectorAll('.rp26-filt').forEach(function (f) { f.classList.remove('is-open'); });
      if (!wasOpen) box.classList.add('is-open');
      e.stopPropagation();
      return;
    }
    if (e.target.closest('.rp26-panel')) return;
    d.querySelectorAll('.rp26-filt').forEach(function (f) { f.classList.remove('is-open'); });
  });

  d.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    d.querySelectorAll('.rp26-filt').forEach(function (f) { f.classList.remove('is-open'); });
    closeDrawer();
  });

  /* --- 3. URL propre : on retire les champs vides avant l'envoi --- */
  function dropEmptyFields(form) {
    form.querySelectorAll('input[type="number"], input[type="text"]').forEach(function (input) {
      if (input.value === '') input.disabled = true;
    });
  }
  d.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('.rp26-filters, .rp26-sheet-form')) return;
    dropEmptyFields(form);
  });

  /* --- 3 bis. Tranches de prix : on remplit les deux paramètres du filtre --- */
  d.addEventListener('change', function (e) {
    var opt = e.target;
    if (!opt.matches || !opt.matches('[data-rp26-price-option]')) return;
    var box = opt.closest('[data-rp26-price]');
    var form = opt.closest('form');
    if (!box || !form) return;
    [['min', 'gte'], ['max', 'lte']].forEach(function (pair) {
      var field = box.querySelector('[data-rp26-price-' + pair[0] + ']');
      var val = opt.getAttribute('data-' + pair[1]);
      if (!field) return;
      if (val) { field.value = val; field.disabled = false; }
      else { field.value = ''; field.disabled = true; }
    });
    // les boutons radio ne servent qu'à l'affichage : on les sort de l'URL
    form.querySelectorAll('[data-rp26-price-option]').forEach(function (r) { r.disabled = true; });
    dropEmptyFields(form);
    form.submit();
  });

  /* --- 4. Soumission automatique des filtres (desktop) --- */
  d.addEventListener('change', function (e) {
    var input = e.target;
    if (input.matches && input.matches('[data-rp26-price-option]')) return;
    if (!input.matches('[data-rp26-autosubmit] input, [data-rp26-autosubmit] select')) return;
    var form = input.closest('form');
    if (!form) return;
    dropEmptyFields(form);
    form.submit();
  });

  /* --- 4. Tiroir de filtres (mobile) --- */
  function openDrawer() {
    var dr = d.querySelector('.rp26-drawer');
    if (!dr) return;
    dr.classList.add('is-open');
    dr.setAttribute('aria-hidden', 'false');
    d.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var dr = d.querySelector('.rp26-drawer');
    if (!dr) return;
    dr.classList.remove('is-open');
    dr.setAttribute('aria-hidden', 'true');
    d.body.style.overflow = '';
  }

  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-rp26-open-drawer]')) { openDrawer(); return; }
    if (e.target.closest('[data-rp26-close-drawer]')) { closeDrawer(); return; }

    var acc = e.target.closest('.rp26-acc > button');
    if (acc) { acc.parentNode.classList.toggle('is-open'); return; }

    var view = e.target.closest('[data-rp26-view]');
    if (view) {
      var n = view.getAttribute('data-rp26-view');
      var grid = d.querySelector('.rp26-grid');
      if (grid) grid.classList.toggle('rp26-view-one', n === '1');
      d.querySelectorAll('[data-rp26-view]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-rp26-view') === n);
      });
      try { localStorage.setItem('rp26-view', n); } catch (err) {}
      return;
    }

    var top = e.target.closest('[data-rp26-totop]');
    if (top) { window.scrollTo({ top: 0, behavior: 'smooth' }); }
  });

  // vue mémorisée
  try {
    var savedView = localStorage.getItem('rp26-view');
    if (savedView === '1') {
      var g = d.querySelector('.rp26-grid');
      if (g) g.classList.add('rp26-view-one');
      d.querySelectorAll('[data-rp26-view]').forEach(function (b) {
        b.classList.toggle('is-on', b.getAttribute('data-rp26-view') === '1');
      });
    }
  } catch (err) {}

  /* --- 5. Bandeaux tournants --- */
  d.querySelectorAll('[data-rp26-rotate]').forEach(function (band) {
    var slides = band.querySelectorAll('.rp26-slide');
    if (slides.length < 2) return;
    var delay = parseInt(band.getAttribute('data-rp26-rotate'), 10) || 3500;
    var i = 0;
    setInterval(function () {
      slides[i % slides.length].classList.remove('is-on');
      i++;
      slides[i % slides.length].classList.add('is-on');
    }, delay);
  });

  /* --- 6. Pastilles couleur : une seule ligne + compteur « +N » --- */
  function swatchLimit() {
    return window.innerWidth < 750 ? 4 : 6;
  }
  function trimSwatches() {
    var limit = swatchLimit();
    d.querySelectorAll('.rp26-scope .card-colorswatches__container').forEach(function (box) {
      var more = box.querySelector('.rp26-swmore');
      if (more) more.remove();
      var swatches = box.querySelectorAll('.card-colorswatch');
      // aucun coloris : on supprime l'espace réservé sous le flux
      box.classList.toggle('rp26-empty', swatches.length === 0);
      swatches.forEach(function (s, i) { s.classList.toggle('rp26-hidden', i >= limit); });
      if (swatches.length > limit) {
        var em = d.createElement('em');
        em.className = 'rp26-swmore';
        em.textContent = '+' + (swatches.length - limit);
        box.appendChild(em);
      }
    });
  }
  trimSwatches();
  window.addEventListener('resize', trimSwatches);
  window.addEventListener('load', trimSwatches);

  /* --- 6 bis. Les encarts prennent exactement la hauteur du visuel produit --- */
  function sizeInserts() {
    d.querySelectorAll('.rp26-grid').forEach(function (grid) {
      var media = grid.querySelector('.card__media');
      if (!media) return;
      var h = Math.round(media.getBoundingClientRect().height);
      if (h > 40) grid.style.setProperty('--rp26-cell-h', h + 'px');
    });
  }
  sizeInserts();
  window.addEventListener('resize', sizeInserts);
  window.addEventListener('load', sizeInserts);
  d.querySelectorAll('.rp26-grid .card__media img').forEach(function (img) {
    if (!img.complete) img.addEventListener('load', sizeInserts, { once: true });
  });

  /* --- 7. Carte flux : rotation des trois niveaux d'absorption --- */
  d.querySelectorAll('[data-rp26-flux]').forEach(function (card) {
    var levels = card.querySelectorAll('.rp26-fluxcard-level');
    var dots = card.querySelectorAll('.rp26-fluxcard-dots i');
    if (levels.length < 2) return;
    var delay = parseInt(card.getAttribute('data-rp26-flux'), 10) || 2500;
    var i = 0;
    setInterval(function () {
      levels[i % levels.length].classList.remove('is-on');
      if (dots[i % levels.length]) dots[i % levels.length].classList.remove('is-on');
      i++;
      levels[i % levels.length].classList.add('is-on');
      if (dots[i % levels.length]) dots[i % levels.length].classList.add('is-on');
    }, delay);
  });

  /* --- 8. Flèches de défilement des rangées --- */
  function refreshNavs() {
    d.querySelectorAll('[data-rp26-track]').forEach(function (row) {
      var nav = d.querySelector('[data-rp26-nav="' + row.getAttribute('data-rp26-track') + '"]');
      if (!nav) return;
      var max = row.scrollWidth - row.clientWidth - 2;
      var btns = nav.querySelectorAll('button');
      if (btns.length < 2) return;
      btns[0].disabled = row.scrollLeft <= 2;
      btns[1].disabled = row.scrollLeft >= max;
    });
  }

  d.addEventListener('click', function (e) {
    var arrow = e.target.closest('[data-rp26-scroll]');
    if (!arrow) return;
    var nav = arrow.closest('[data-rp26-nav]');
    if (!nav) return;
    var row = d.querySelector('[data-rp26-track="' + nav.getAttribute('data-rp26-nav') + '"]');
    if (!row) return;
    var dir = arrow.getAttribute('data-rp26-scroll') === 'next' ? 1 : -1;
    row.scrollBy({ left: dir * Math.round(row.clientWidth * 0.75), behavior: 'smooth' });
  });

  d.querySelectorAll('[data-rp26-track]').forEach(function (row) {
    row.addEventListener('scroll', refreshNavs, { passive: true });
  });
  window.addEventListener('resize', refreshNavs);
  refreshNavs();

  // L'éditeur de thème recharge les sections : on rebranche l'essentiel.
  d.addEventListener('shopify:section:load', function () {
    stickyTop();
    refreshNavs();
  });
})();
